import {useQuery, gql} from "@apollo/client";
var  HOME_SERVICES = gql`
query MyQuery {
    homeServices(where: {localization: {culture_starts_with: "fa"}}) {
      bag {
        contentItems {
          ... on HomeServiceItem {
            id
            displayText
            serviceImage {
              urls(first: 1)
            }
            serviceOverview {
              html
            }
          }
        }
      }
      displayText
    }
  }
`;

export const useHomeServices = () => {
  const {error, loading, data} = useQuery(HOME_SERVICES);
  
  return {
    error, data, loading
  };
  } 